import * as y from "react";
import { usePrevious as Ct, useResizeListener as Vt, useEventListener as Mt, useMountEffect as xt, useUpdateEffect as ve, Ripple as $t, Portal as jt, PrimeReact as Xe, useOverlayListener as Ht, useUnmountEffect as Gt, FilterService as Lt, localeOption as Et } from "./portal.esm.79076359.js";
import { EventBus as Wt, ObjectUtils as S, jsxs as ue, Fragment as Ee, classNames as B, DomHandler as j, jsx as I, ZIndexUtils as yt } from "./utils.esm.ea524c19.js";
import { Tooltip as At } from "./tooltip.esm.f9603bda.js";
import { CSSTransition as Ut } from "./csstransition.esm.5346b5f2.js";
var pt = Wt();
function Bt(e, r, n) {
  return r in e ? Object.defineProperty(e, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = n, e;
}
function Jt(e) {
  if (Array.isArray(e))
    return e;
}
function Xt(e, r) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var l = [], c = !0, T = !1, K, h;
    try {
      for (n = n.call(e); !(c = (K = n.next()).done) && (l.push(K.value), !(r && l.length === r)); c = !0)
        ;
    } catch (z) {
      T = !0, h = z;
    } finally {
      try {
        !c && n.return != null && n.return();
      } finally {
        if (T)
          throw h;
      }
    }
    return l;
  }
}
function Rt(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var n = 0, l = new Array(r); n < r; n++)
    l[n] = e[n];
  return l;
}
function qt(e, r) {
  if (!!e) {
    if (typeof e == "string")
      return Rt(e, r);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Rt(e, r);
  }
}
function Yt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function de(e, r) {
  return Jt(e) || Xt(e, r) || qt(e, r) || Yt();
}
function Tt(e, r) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    r && (l = l.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), n.push.apply(n, l);
  }
  return n;
}
function Zt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Tt(Object(n), !0).forEach(function(l) {
      Bt(e, l, n[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Tt(Object(n)).forEach(function(l) {
      Object.defineProperty(e, l, Object.getOwnPropertyDescriptor(n, l));
    });
  }
  return e;
}
var Ye = /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef(function(e, r) {
  var n = e.orientation === "vertical", l = e.orientation === "horizontal", c = e.orientation === "both", T = y.useState(c ? {
    rows: 0,
    cols: 0
  } : 0), K = de(T, 2), h = K[0], z = K[1], H = y.useState(c ? {
    rows: 0,
    cols: 0
  } : 0), Q = de(H, 2), C = Q[0], L = Q[1], te = y.useState(c ? {
    rows: 0,
    cols: 0
  } : 0), G = de(te, 2), E = G[0], k = G[1], ne = y.useState(e.numToleratedItems), _ = de(ne, 2), d = _[0], D = _[1], V = y.useState(e.loading || !1), R = de(V, 2), x = R[0], J = R[1], oe = y.useState([]), ce = de(oe, 2), re = ce[0], Ze = ce[1], P = y.useRef(null), W = y.useRef(null), ye = y.useRef(null), be = y.useRef(null), ae = y.useRef(c ? {
    top: 0,
    left: 0
  } : 0), Re = y.useRef(null), Te = y.useRef(null), fe = y.useRef(null), se = y.useRef(null), Ke = Ct(e.items), ke = Ct(e.loading), _e = Vt({
    listener: function(a) {
      return We();
    }
  }), Ve = de(_e, 1), Qe = Ve[0], et = Mt({
    target: "window",
    type: "orientationchange",
    listener: function(a) {
      return We();
    }
  }), Me = de(et, 1), tt = Me[0], Pe = function() {
    return P;
  }, Fe = function(a) {
    ae.current = c ? {
      top: 0,
      left: 0
    } : 0, P.current && P.current.scrollTo(a);
  }, $e = function(a) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto", f = je(), v = f.numToleratedItems, m = function() {
      var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, o = arguments.length > 1 ? arguments[1] : void 0;
      return A <= o ? 0 : A;
    }, s = function(A, o) {
      return A * o;
    }, b = function() {
      var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return Fe({
        left: A,
        top: o,
        behavior: i
      });
    };
    if (c) {
      var F = {
        rows: m(a[0], v[0]),
        cols: m(a[1], v[1])
      };
      (F.rows !== h.rows || F.cols !== h.cols) && b(s(F.cols, e.itemSize[1]), s(F.rows, e.itemSize[0]));
    } else {
      var N = m(a, v);
      N !== h && (l ? b(s(N, e.itemSize), 0) : b(0, s(N, e.itemSize)));
    }
  }, nt = function(a, i) {
    var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "auto";
    if (i) {
      var v = Se(), m = v.first, s = v.viewport, b = function() {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return Fe({
          left: t,
          top: u,
          behavior: f
        });
      }, F = i === "to-start", N = i === "to-end";
      if (F) {
        if (c)
          s.first.rows - m.rows > a[0] ? b(s.first.cols * e.itemSize[1], (s.first.rows - 1) * e.itemSize[0]) : s.first.cols - m.cols > a[1] && b((s.first.cols - 1) * e.itemSize[1], s.first.rows * e.itemSize[0]);
        else if (s.first - m > a) {
          var M = (s.first - 1) * e.itemSize;
          l ? b(M, 0) : b(0, M);
        }
      } else if (N) {
        if (c)
          s.last.rows - m.rows <= a[0] + 1 ? b(s.first.cols * e.itemSize[1], (s.first.rows + 1) * e.itemSize[0]) : s.last.cols - m.cols <= a[1] + 1 && b((s.first.cols + 1) * e.itemSize[1], s.first.rows * e.itemSize[0]);
        else if (s.last - m <= a + 1) {
          var A = (s.first + 1) * e.itemSize;
          l ? b(A, 0) : b(0, A);
        }
      }
    } else
      $e(a, f);
  }, rt = function() {
    return x ? e.loaderDisabled ? re : [] : Ie();
  }, at = function() {
    return e.columns && c || l ? x && e.loaderDisabled ? c ? re[0] : re : e.columns.slice(c ? h.cols : h, c ? C.cols : C) : e.columns;
  }, Se = function() {
    var a = function(N, M) {
      return Math.floor(N / (M || N));
    }, i = h, f = 0;
    if (P.current) {
      var v = P.current, m = v.scrollTop, s = v.scrollLeft;
      if (c)
        i = {
          rows: a(m, e.itemSize[0]),
          cols: a(s, e.itemSize[1])
        }, f = {
          rows: i.rows + E.rows,
          cols: i.cols + E.cols
        };
      else {
        var b = l ? s : m;
        i = a(b, e.itemSize), f = i + E;
      }
    }
    return {
      first: h,
      last: C,
      viewport: {
        first: i,
        last: f
      }
    };
  }, je = function() {
    var a = Oe(), i = P.current ? P.current.offsetWidth - a.left : 0, f = P.current ? P.current.offsetHeight - a.top : 0, v = function(N, M) {
      return Math.ceil(N / (M || N));
    }, m = function(N) {
      return Math.ceil(N / 2);
    }, s = c ? {
      rows: v(f, e.itemSize[0]),
      cols: v(i, e.itemSize[1])
    } : v(l ? i : f, e.itemSize), b = d || (c ? [m(s.rows), m(s.cols)] : m(s));
    return {
      numItemsInViewport: s,
      numToleratedItems: b
    };
  }, we = function() {
    var a = je(), i = a.numItemsInViewport, f = a.numToleratedItems, v = function(b, F, N, M) {
      return Ne(b + F + (b < N ? 2 : 3) * N, M);
    }, m = c ? {
      rows: v(h.rows, i.rows, f[0]),
      cols: v(h.cols, i.cols, f[1], !0)
    } : v(h, i, f);
    k(i), D(f), L(m), e.showLoader && Ze(c ? Array.from({
      length: i.rows
    }).map(function() {
      return Array.from({
        length: i.cols
      });
    }) : Array.from({
      length: i
    })), e.lazy && e.onLazyLoad && e.onLazyLoad({
      first: h,
      last: m
    });
  }, me = function(a) {
    e.autoSize && !a && Promise.resolve().then(function() {
      if (W.current) {
        W.current.style.minHeight = W.current.style.minWidth = "auto";
        var i = W.current, f = i.offsetWidth, v = i.offsetHeight;
        (c || l) && (P.current.style.width = (f < fe.current ? f : fe.current) + "px"), (c || n) && (P.current.style.height = (v < se.current ? v : se.current) + "px"), W.current.style.minHeight = W.current.style.minWidth = "";
      }
    });
  }, Ne = function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, i = arguments.length > 1 ? arguments[1] : void 0;
    return e.items ? Math.min(i ? (e.columns || e.items[0]).length : e.items.length, a) : 0;
  }, Oe = function() {
    if (W.current) {
      var a = getComputedStyle(W.current), i = parseInt(a.paddingLeft, 10) + Math.max(parseInt(a.left, 10), 0), f = parseInt(a.paddingRight, 10) + Math.max(parseInt(a.right, 10), 0), v = parseInt(a.paddingTop, 10) + Math.max(parseInt(a.top, 10), 0), m = parseInt(a.paddingBottom, 10) + Math.max(parseInt(a.bottom, 10), 0);
      return {
        left: i,
        right: f,
        top: v,
        bottom: m,
        x: i + f,
        y: v + m
      };
    }
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      x: 0,
      y: 0
    };
  }, lt = function() {
    if (P.current) {
      var a = P.current.parentElement, i = e.scrollWidth || "".concat(P.current.offsetWidth || a.offsetWidth, "px"), f = e.scrollHeight || "".concat(P.current.offsetHeight || a.offsetHeight, "px"), v = function(s, b) {
        return P.current.style[s] = b;
      };
      c || l ? (v("height", f), v("width", i)) : v("height", f);
    }
  }, ge = function() {
    var a = e.items;
    if (ye.current && a) {
      var i = Oe(), f = function(m, s, b) {
        var F = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        return ye.current.style[m] = (s || []).length * b + F + "px";
      };
      c ? (f("height", a, e.itemSize[0], i.y), f("width", e.columns || a[1], e.itemSize[1], i.x)) : l ? f("width", e.columns || a, e.itemSize, i.x) : f("height", a, e.itemSize, i.y);
    }
  }, X = function(a) {
    if (W.current) {
      var i = a ? a.first : h, f = function(b, F) {
        return b * F;
      }, v = function() {
        var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        be.current && (be.current.style.top = "-".concat(F, "px")), W.current.style.transform = "translate3d(".concat(b, "px, ").concat(F, "px, 0)");
      };
      if (c)
        v(f(i.cols, e.itemSize[1]), f(i.rows, e.itemSize[0]));
      else {
        var m = f(i, e.itemSize);
        l ? v(m, 0) : v(0, m);
      }
    }
  }, He = function(a) {
    var i = a.target, f = Oe(), v = function($, Z) {
      return $ ? $ > Z ? $ - Z : $ : 0;
    }, m = function($, Z) {
      return Math.floor($ / (Z || $));
    }, s = function($, Z, xe, Be, ie, he) {
      return $ <= ie ? ie : he ? xe - Be - ie : Z + ie - 1;
    }, b = function($, Z, xe, Be, ie, he, Je) {
      return $ <= he ? 0 : Math.max(0, Je ? $ < Z ? xe : $ - he : $ > Z ? xe : $ - 2 * he);
    }, F = function($, Z, xe, Be, ie, he) {
      var Je = Z + Be + 2 * ie;
      return $ >= ie && (Je += ie + 1), Ne(Je, he);
    }, N = v(i.scrollTop, f.top), M = v(i.scrollLeft, f.left), A = c ? {
      rows: 0,
      cols: 0
    } : 0, o = C, t = !1, u = ae.current;
    if (c) {
      var g = ae.current.top <= N, O = ae.current.left <= M, U = {
        rows: m(N, e.itemSize[0]),
        cols: m(M, e.itemSize[1])
      }, ee = {
        rows: s(U.rows, h.rows, C.rows, E.rows, d[0], g),
        cols: s(U.cols, h.cols, C.cols, E.cols, d[1], O)
      };
      A = {
        rows: b(U.rows, ee.rows, h.rows, C.rows, E.rows, d[0], g),
        cols: b(U.cols, ee.cols, h.cols, C.cols, E.cols, d[1], O)
      }, o = {
        rows: F(U.rows, A.rows, C.rows, E.rows, d[0]),
        cols: F(U.cols, A.cols, C.cols, E.cols, d[1], !0)
      }, t = A.rows !== h.rows || o.rows !== C.rows || A.cols !== h.cols || o.cols !== C.cols, u = {
        top: N,
        left: M
      };
    } else {
      var Y = l ? M : N, le = ae.current <= Y, ht = m(Y, e.itemSize), _t = s(ht, h, C, E, d, le);
      A = b(ht, _t, h, C, E, d, le), o = F(ht, A, C, E, d), t = A !== h || o !== C, u = Y;
    }
    return {
      first: A,
      last: o,
      isRangeChanged: t,
      scrollPos: u
    };
  }, Ge = function(a) {
    var i = He(a), f = i.first, v = i.last, m = i.isRangeChanged, s = i.scrollPos;
    if (m) {
      var b = {
        first: f,
        last: v
      };
      X(b), z(f), L(v), ae.current = s, e.onScrollIndexChange && e.onScrollIndexChange(b), e.lazy && e.onLazyLoad && e.onLazyLoad(b);
    }
  }, it = function(a) {
    if (e.onScroll && e.onScroll(a), e.delay) {
      if (Re.current && clearTimeout(Re.current), !x && e.showLoader) {
        var i = He(a), f = i.isRangeChanged;
        f && J(!0);
      }
      Re.current = setTimeout(function() {
        Ge(a), x && e.showLoader && (!e.lazy || e.loading === void 0) && J(!1);
      }, e.delay);
    } else
      Ge(a);
  }, We = function() {
    Te.current && clearTimeout(Te.current), Te.current = setTimeout(function() {
      if (P.current) {
        var a = [j.getWidth(P.current), j.getHeight(P.current)], i = a[0], f = a[1], v = i !== fe.current, m = f !== se.current, s = c ? v || m : l ? v : n ? m : !1;
        s && (D(e.numToleratedItems), fe.current = i, se.current = f);
      }
    }, e.resizeDelay);
  }, De = function(a) {
    var i = (e.items || []).length, f = c ? h.rows + a : h + a;
    return {
      index: f,
      count: i,
      first: f === 0,
      last: f === i - 1,
      even: f % 2 === 0,
      odd: f % 2 !== 0,
      props: e
    };
  }, Ue = function(a, i) {
    var f = re.length;
    return Zt({
      index: a,
      count: f,
      first: a === 0,
      last: a === f - 1,
      even: a % 2 === 0,
      odd: a % 2 !== 0,
      props: e
    }, i);
  }, Ie = function() {
    var a = e.items;
    return a && !x ? c ? a.slice(h.rows, C.rows).map(function(i) {
      return e.columns ? i : i.slice(h.cols, C.cols);
    }) : l && e.columns ? a : a.slice(h, C) : [];
  }, p = function() {
    e.disabled || (lt(), we(), ge());
  };
  xt(function() {
    e.disabled || (p(), Qe(), tt(), fe.current = j.getWidth(P.current), se.current = j.getHeight(P.current));
  }), ve(function() {
    p();
  }, [e.itemSize, e.scrollHeight]), ve(function() {
    e.numToleratedItems !== d && D(e.numToleratedItems);
  }, [e.numToleratedItems]), ve(function() {
    e.numToleratedItems === d && p();
  }, [d]), ve(function() {
    (!Ke || Ke.length !== (e.items || []).length) && p();
    var w = x;
    e.lazy && ke !== e.loading && e.loading !== x && (J(e.loading), w = e.loading), me(w);
  }), ve(function() {
    ae.current = c ? {
      top: 0,
      left: 0
    } : 0;
  }, [e.orientation]), y.useImperativeHandle(r, function() {
    return {
      props: e,
      getElementRef: Pe,
      scrollTo: Fe,
      scrollToIndex: $e,
      scrollInView: nt,
      getRenderedRange: Se
    };
  });
  var Ce = function(a) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, f = Ue(a, i), v = S.getJSXElement(e.loadingTemplate, f);
    return /* @__PURE__ */ I(Ee, {
      children: v
    });
  }, ut = function() {
    if (!e.loaderDisabled && e.showLoader && x) {
      var a = B("p-virtualscroller-loader", {
        "p-component-overlay": !e.loadingTemplate
      }), i = /* @__PURE__ */ I("i", {
        className: "p-virtualscroller-loading-icon pi pi-spinner pi-spin"
      });
      if (e.loadingTemplate)
        i = re.map(function(v, m) {
          return Ce(m, c && {
            numCols: E.cols
          });
        });
      else if (e.loaderIconTemplate) {
        var f = {
          className: "p-virtualscroller-loading-icon",
          element: i,
          props: e
        };
        i = S.getJSXElement(e.loaderIconTemplate, f);
      }
      return /* @__PURE__ */ I("div", {
        className: a,
        children: i
      });
    }
    return null;
  }, ze = function() {
    return e.showSpacer ? /* @__PURE__ */ I("div", {
      ref: ye,
      className: "p-virtualscroller-spacer"
    }) : null;
  }, ot = function(a, i) {
    var f = De(i), v = S.getJSXElement(e.itemTemplate, a, f);
    return /* @__PURE__ */ I(Ee, {
      children: v
    });
  }, ct = function() {
    var a = Ie();
    return a.map(ot);
  }, q = function() {
    var a = ct(), i = B("p-virtualscroller-content", {
      "p-virtualscroller-loading": x
    }), f = /* @__PURE__ */ I("div", {
      ref: W,
      className: i,
      children: a
    });
    if (e.contentTemplate) {
      var v = {
        className: i,
        contentRef: function(s) {
          return W.current = S.getRefElement(s);
        },
        spacerRef: function(s) {
          return ye.current = S.getRefElement(s);
        },
        stickyRef: function(s) {
          return be.current = S.getRefElement(s);
        },
        items: Ie(),
        getItemOptions: function(s) {
          return De(s);
        },
        children: a,
        element: f,
        props: e,
        loading: x,
        getLoaderOptions: function(s, b) {
          return Ue(s, b);
        },
        loadingTemplate: e.loadingTemplate,
        itemSize: e.itemSize,
        rows: rt(),
        columns: at(),
        vertical: n,
        horizontal: l,
        both: c
      };
      return S.getJSXElement(e.contentTemplate, v);
    }
    return f;
  };
  if (e.disabled) {
    var ft = S.getJSXElement(e.contentTemplate, {
      items: e.items,
      rows: e.items,
      columns: e.columns
    });
    return /* @__PURE__ */ ue(Ee, {
      children: [e.children, ft]
    });
  } else {
    var st = S.findDiffKeys(e, Ye.defaultProps), dt = B("p-virtualscroller", {
      "p-both-scroll": c,
      "p-horizontal-scroll": l
    }, e.className), vt = ut(), mt = q(), gt = ze();
    return /* @__PURE__ */ ue("div", {
      ref: P,
      className: dt,
      tabIndex: 0,
      style: e.style,
      ...st,
      onScroll: it,
      children: [mt, gt, vt]
    });
  }
}));
Ye.displayName = "VirtualScroller";
Ye.defaultProps = {
  __TYPE: "VirtualScroller",
  id: null,
  style: null,
  className: null,
  items: null,
  itemSize: 0,
  scrollHeight: null,
  scrollWidth: null,
  orientation: "vertical",
  numToleratedItems: null,
  delay: 0,
  resizeDelay: 10,
  lazy: !1,
  disabled: !1,
  loaderDisabled: !1,
  columns: null,
  loading: void 0,
  autoSize: !1,
  showSpacer: !0,
  showLoader: !1,
  loadingTemplate: null,
  loaderIconTemplate: null,
  itemTemplate: null,
  contentTemplate: null,
  onScroll: null,
  onScrollIndexChange: null,
  onLazyLoad: null
};
function bt(e) {
  return bt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, bt(e);
}
function Kt(e, r, n) {
  return r in e ? Object.defineProperty(e, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = n, e;
}
function Qt(e) {
  if (Array.isArray(e))
    return e;
}
function en(e, r) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var l = [], c = !0, T = !1, K, h;
    try {
      for (n = n.call(e); !(c = (K = n.next()).done) && (l.push(K.value), !(r && l.length === r)); c = !0)
        ;
    } catch (z) {
      T = !0, h = z;
    } finally {
      try {
        !c && n.return != null && n.return();
      } finally {
        if (T)
          throw h;
      }
    }
    return l;
  }
}
function Pt(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var n = 0, l = new Array(r); n < r; n++)
    l[n] = e[n];
  return l;
}
function tn(e, r) {
  if (!!e) {
    if (typeof e == "string")
      return Pt(e, r);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Pt(e, r);
  }
}
function nn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qe(e, r) {
  return Qt(e) || en(e, r) || tn(e, r) || nn();
}
var St = /* @__PURE__ */ y.memo(function(e) {
  var r = function(T) {
    e.onClick && e.onClick({
      originalEvent: T,
      option: e.option
    });
  }, n = B("p-dropdown-item", {
    "p-highlight": e.selected,
    "p-disabled": e.disabled,
    "p-dropdown-item-empty": !e.label || e.label.length === 0
  }, e.option && e.option.className), l = e.template ? S.getJSXElement(e.template, e.option) : e.label;
  return /* @__PURE__ */ ue("li", {
    className: n,
    style: e.style,
    onClick: r,
    "aria-label": e.label,
    role: "option",
    "aria-selected": e.selected,
    children: [l, /* @__PURE__ */ I($t, {})]
  }, e.label);
});
St.displayName = "DropdownItem";
function Ft(e, r) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    r && (l = l.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), n.push.apply(n, l);
  }
  return n;
}
function Le(e) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Ft(Object(n), !0).forEach(function(l) {
      Kt(e, l, n[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ft(Object(n)).forEach(function(l) {
      Object.defineProperty(e, l, Object.getOwnPropertyDescriptor(n, l));
    });
  }
  return e;
}
var kt = /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef(function(e, r) {
  var n = y.useRef(null), l = y.useRef(null), c = !(e.visibleOptions && e.visibleOptions.length) && e.hasFilter, T = {
    filter: function(d) {
      return z(d);
    },
    reset: function() {
      return e.resetFilter();
    }
  }, K = function() {
    e.onEnter(function() {
      if (n.current) {
        var d = e.getSelectedOptionIndex();
        d !== -1 && setTimeout(function() {
          return n.current.scrollToIndex(d);
        }, 0);
      }
    });
  }, h = function() {
    e.onEntered(function() {
      e.filter && e.filterInputAutoFocus && j.focus(l.current, !1);
    });
  }, z = function(d) {
    n.current && n.current.scrollToIndex(0), e.onFilterInputChange && e.onFilterInputChange(d);
  }, H = function(d, D) {
    var V = e.getOptionGroupChildren(d);
    return V.map(function(R, x) {
      var J = e.getOptionLabel(R), oe = x + "_" + e.getOptionRenderKey(R), ce = e.isOptionDisabled(R);
      return /* @__PURE__ */ I(St, {
        label: J,
        option: R,
        style: D,
        template: e.itemTemplate,
        selected: e.isSelected(R),
        disabled: ce,
        onClick: e.onOptionClick
      }, oe);
    });
  }, Q = function(d, D) {
    var V = S.getJSXElement(d, e) || Et(D ? "emptyFilterMessage" : "emptyMessage");
    return /* @__PURE__ */ I("li", {
      className: "p-dropdown-empty-message",
      children: V
    });
  }, C = function(d, D) {
    var V = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, R = {
      height: V.props ? V.props.itemSize : void 0
    };
    if (e.optionGroupLabel) {
      var x = e.optionGroupTemplate ? S.getJSXElement(e.optionGroupTemplate, d, D) : e.getOptionGroupLabel(d), J = H(d, R);
      return D + "" + e.getOptionGroupRenderKey(d), /* @__PURE__ */ ue(Ee, {
        children: [/* @__PURE__ */ I("li", {
          className: "p-dropdown-item-group",
          style: R,
          children: x
        }), J]
      });
    } else {
      var oe = e.getOptionLabel(d), ce = D + "_" + e.getOptionRenderKey(d), re = e.isOptionDisabled(d);
      return /* @__PURE__ */ I(St, {
        label: oe,
        option: d,
        style: R,
        template: e.itemTemplate,
        selected: e.isSelected(d),
        disabled: re,
        onClick: e.onOptionClick
      }, ce);
    }
  }, L = function() {
    return S.isNotEmpty(e.visibleOptions) ? e.visibleOptions.map(C) : e.hasFilter ? Q(e.emptyFilterMessage, !0) : Q(e.emptyMessage);
  }, te = function() {
    if (e.showFilterClear && e.filterValue) {
      var d = Et("clear");
      return /* @__PURE__ */ I("i", {
        className: "p-dropdown-filter-clear-icon pi pi-times",
        "aria-label": d,
        onClick: function() {
          return e.onFilterClearIconClick(function() {
            return j.focus(l.current);
          });
        }
      });
    }
    return null;
  }, G = function() {
    if (e.filter) {
      var d = te(), D = B("p-dropdown-filter-container", {
        "p-dropdown-clearable-filter": !!d
      }), V = /* @__PURE__ */ ue("div", {
        className: D,
        children: [/* @__PURE__ */ I("input", {
          ref: l,
          type: "text",
          autoComplete: "off",
          className: "p-dropdown-filter p-inputtext p-component",
          placeholder: e.filterPlaceholder,
          onKeyDown: e.onFilterInputKeyDown,
          onChange: z,
          value: e.filterValue
        }), d, /* @__PURE__ */ I("i", {
          className: "p-dropdown-filter-icon pi pi-search"
        })]
      });
      if (e.filterTemplate) {
        var R = {
          className: D,
          element: V,
          filterOptions: T,
          filterInputKeyDown: e.onFilterInputKeyDown,
          filterInputChange: z,
          filterIconClassName: "p-dropdown-filter-icon pi pi-search",
          clearIcon: d,
          props: e
        };
        V = S.getJSXElement(e.filterTemplate, R);
      }
      return /* @__PURE__ */ I("div", {
        className: "p-dropdown-header",
        children: V
      });
    }
    return null;
  }, E = function() {
    if (e.virtualScrollerOptions) {
      var d = Le(Le({}, e.virtualScrollerOptions), {
        style: Le(Le({}, e.virtualScrollerOptions.style), {
          height: e.scrollHeight
        }),
        className: B("p-dropdown-items-wrapper", e.virtualScrollerOptions.className),
        items: e.visibleOptions,
        autoSize: !0,
        onLazyLoad: function(R) {
          return e.virtualScrollerOptions.onLazyLoad(Le(Le({}, R), {
            filter: e.filterValue
          }));
        },
        itemTemplate: function(R, x) {
          return R && C(R, x.index, x);
        },
        contentTemplate: function(R) {
          var x = B("p-dropdown-items", R.className), J = c ? Q() : R.children;
          return /* @__PURE__ */ I("ul", {
            ref: R.contentRef,
            className: x,
            role: "listbox",
            children: J
          });
        }
      });
      return /* @__PURE__ */ I(Ye, {
        ref: n,
        ...d
      });
    } else {
      var D = L();
      return /* @__PURE__ */ I("div", {
        className: "p-dropdown-items-wrapper",
        style: {
          maxHeight: e.scrollHeight || "auto"
        },
        children: /* @__PURE__ */ I("ul", {
          className: "p-dropdown-items",
          role: "listbox",
          children: D
        })
      });
    }
  }, k = function() {
    var d = B("p-dropdown-panel p-component", e.panelClassName), D = G(), V = E();
    return /* @__PURE__ */ I(Ut, {
      nodeRef: r,
      classNames: "p-connected-overlay",
      in: e.in,
      timeout: {
        enter: 120,
        exit: 100
      },
      options: e.transitionOptions,
      unmountOnExit: !0,
      onEnter: K,
      onEntering: e.onEntering,
      onEntered: h,
      onExit: e.onExit,
      onExited: e.onExited,
      children: /* @__PURE__ */ ue("div", {
        ref: r,
        className: d,
        style: e.panelStyle,
        onClick: e.onClick,
        children: [D, V]
      })
    });
  }, ne = k();
  return /* @__PURE__ */ I(jt, {
    element: ne,
    appendTo: e.appendTo
  });
}));
kt.displayName = "DropdownPanel";
function Nt(e, r) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    r && (l = l.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), n.push.apply(n, l);
  }
  return n;
}
function Dt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Nt(Object(n), !0).forEach(function(l) {
      Kt(e, l, n[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nt(Object(n)).forEach(function(l) {
      Object.defineProperty(e, l, Object.getOwnPropertyDescriptor(n, l));
    });
  }
  return e;
}
function rn(e, r) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = an(e)) || r && e && typeof e.length == "number") {
      n && (e = n);
      var l = 0, c = function() {
      };
      return {
        s: c,
        n: function() {
          return l >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[l++]
          };
        },
        e: function(H) {
          throw H;
        },
        f: c
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var T = !0, K = !1, h;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var H = n.next();
      return T = H.done, H;
    },
    e: function(H) {
      K = !0, h = H;
    },
    f: function() {
      try {
        !T && n.return != null && n.return();
      } finally {
        if (K)
          throw h;
      }
    }
  };
}
function an(e, r) {
  if (!!e) {
    if (typeof e == "string")
      return zt(e, r);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return zt(e, r);
  }
}
function zt(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var n = 0, l = new Array(r); n < r; n++)
    l[n] = e[n];
  return l;
}
var Ot = /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef(function(e, r) {
  var n = y.useState(""), l = qe(n, 2), c = l[0], T = l[1], K = y.useState(!1), h = qe(K, 2), z = h[0], H = h[1], Q = y.useState(!1), C = qe(Q, 2), L = C[0], te = C[1], G = y.useRef(null), E = y.useRef(null), k = y.useRef(e.inputRef), ne = y.useRef(null), _ = y.useRef(null), d = y.useRef(null), D = y.useRef(null), V = e.virtualScrollerOptions && e.virtualScrollerOptions.lazy, R = S.isNotEmpty(c), x = e.appendTo || Xe.appendTo, J = Ht({
    target: G,
    overlay: E,
    listener: function(t, u) {
      var g = u.type, O = u.valid;
      O && (g === "outside" ? !P(t) && X() : X());
    },
    when: L
  }), oe = qe(J, 2), ce = oe[0], re = oe[1], Ze = function() {
    if (R && !V) {
      var t = c.trim().toLocaleLowerCase(e.filterLocale), u = e.filterBy ? e.filterBy.split(",") : [e.optionLabel || "label"];
      if (e.optionGroupLabel) {
        var g = [], O = rn(e.options), U;
        try {
          for (O.s(); !(U = O.n()).done; ) {
            var ee = U.value, Y = Lt.filter(q(ee), u, t, e.filterMatchMode, e.filterLocale);
            Y && Y.length && g.push(Dt(Dt({}, ee), {
              items: Y
            }));
          }
        } catch (le) {
          O.e(le);
        } finally {
          O.f();
        }
        return g;
      } else
        return Lt.filter(e.options, u, t, e.filterMatchMode, e.filterLocale);
    } else
      return e.options;
  }, P = function(t) {
    return j.hasClass(t.target, "p-dropdown-clear-icon") || j.hasClass(t.target, "p-dropdown-filter-clear-icon");
  }, W = function(t) {
    e.disabled || j.hasClass(t.target, "p-dropdown-clear-icon") || t.target.tagName === "INPUT" || (!E.current || !(E.current && E.current.contains(t.target))) && (j.focus(ne.current), L ? X() : ge());
  }, ye = function(t) {
    e.showOnFocus && !L && ge(), H(!0), e.onFocus && e.onFocus(t);
  }, be = function(t) {
    H(!1), e.onBlur && setTimeout(function() {
      var u = k.current ? k.current.value : void 0;
      e.onBlur({
        originalEvent: t.originalEvent,
        value: u,
        stopPropagation: function() {
        },
        preventDefault: function() {
        },
        target: {
          name: e.name,
          id: e.id,
          value: u
        }
      });
    }, 200);
  }, ae = function(t) {
    pt.emit("overlay-click", {
      originalEvent: t,
      target: G.current
    });
  }, Re = function(t) {
    switch (t.which) {
      case 40:
        se(t);
        break;
      case 38:
        fe(t);
        break;
      case 32:
      case 13:
        L ? X() : ge(), t.preventDefault();
        break;
      case 27:
      case 9:
        X();
        break;
      default:
        Qe(t);
        break;
    }
  }, Te = function(t) {
    switch (t.which) {
      case 40:
        se(t);
        break;
      case 38:
        fe(t);
        break;
      case 13:
      case 27:
        X(), t.preventDefault();
        break;
    }
  }, fe = function(t) {
    if (a) {
      var u = _e(me());
      u && we({
        originalEvent: t,
        option: u
      });
    }
    t.preventDefault();
  }, se = function(t) {
    if (a)
      if (!L && t.altKey)
        ge();
      else {
        var u = Ke(me());
        u && we({
          originalEvent: t,
          option: u
        });
      }
    t.preventDefault();
  }, Ke = function o(t) {
    if (e.optionGroupLabel) {
      var u = t === -1 ? 0 : t.group, g = t === -1 ? -1 : t.option, O = ke(q(a[u]), g);
      return O || (u + 1 !== a.length ? o({
        group: u + 1,
        option: -1
      }) : null);
    }
    return ke(a, t);
  }, ke = function o(t, u) {
    var g = u + 1;
    if (g === t.length)
      return null;
    var O = t[g];
    return ze(O) ? o(g) : O;
  }, _e = function o(t) {
    if (t === -1)
      return null;
    if (e.optionGroupLabel) {
      var u = t.group, g = t.option, O = Ve(q(a[u]), g);
      return O || (u > 0 ? o({
        group: u - 1,
        option: q(a[u - 1]).length
      }) : null);
    }
    return Ve(a, t);
  }, Ve = function(t, u) {
    var g = u - 1;
    if (g < 0)
      return null;
    var O = t[g];
    return ze(O) ? _e(g) : O;
  }, Qe = function(t) {
    _.current && clearTimeout(_.current);
    var u = t.key;
    if (!(u === "Shift" || u === "Control" || u === "Alt")) {
      if (D.current === u ? d.current = u : d.current = d.current ? d.current + u : u, D.current = u, d.current) {
        var g = me(), O = e.optionGroupLabel ? tt(g) : et(g + 1);
        O && we({
          originalEvent: t,
          option: O
        });
      }
      _.current = setTimeout(function() {
        d.current = null;
      }, 250);
    }
  }, et = function(t) {
    return d.current ? Me(t, a.length) || Me(0, t) : null;
  }, Me = function(t, u) {
    for (var g = t; g < u; g++) {
      var O = a[g];
      if (Pe(O))
        return O;
    }
    return null;
  }, tt = function(t) {
    for (var u = t === -1 ? {
      group: 0,
      option: -1
    } : t, g = u.group; g < a.length; g++)
      for (var O = q(a[g]), U = u.group === g ? u.option + 1 : 0; U < O.length; U++)
        if (Pe(O[U]))
          return O[U];
    for (var ee = 0; ee <= u.group; ee++)
      for (var Y = q(a[ee]), le = 0; le < (u.group === ee ? u.option : Y.length); le++)
        if (Pe(Y[le]))
          return Y[le];
    return null;
  }, Pe = function(t) {
    var u = p(t);
    return u ? (u = u.toLocaleLowerCase(e.filterLocale), u.startsWith(d.current.toLocaleLowerCase(e.filterLocale))) : !1;
  }, Fe = function(t) {
    e.onChange && e.onChange({
      originalEvent: t.originalEvent,
      value: t.target.value,
      stopPropagation: function() {
      },
      preventDefault: function() {
      },
      target: {
        name: e.name,
        id: e.id,
        value: t.target.value
      }
    });
  }, $e = function(t) {
    H(!0), X(), e.onFocus && e.onFocus(t);
  }, nt = function(t) {
    var u = t.option;
    u.disabled || (we(t), j.focus(ne.current)), X();
  }, rt = function(t) {
    var u = t.target.value;
    T(u), e.onFilter && e.onFilter({
      originalEvent: t,
      filter: u
    });
  }, at = function(t) {
    Se(t);
  }, Se = function(t) {
    T(""), e.onFilter && e.onFilter({
      filter: ""
    }), t && t();
  }, je = function(t) {
    e.onChange && e.onChange({
      originalEvent: t,
      value: void 0,
      stopPropagation: function() {
      },
      preventDefault: function() {
      },
      target: {
        name: e.name,
        id: e.id,
        value: void 0
      }
    }), Ie();
  }, we = function(t) {
    if (i !== t.option) {
      Ie(t.option);
      var u = Ce(t.option);
      e.onChange && e.onChange({
        originalEvent: t.originalEvent,
        value: u,
        stopPropagation: function() {
        },
        preventDefault: function() {
        },
        target: {
          name: e.name,
          id: e.id,
          value: u
        }
      });
    }
  }, me = function(t) {
    if (t = t || a, e.value != null && t)
      if (e.optionGroupLabel)
        for (var u = 0; u < t.length; u++) {
          var g = Oe(e.value, q(t[u]));
          if (g !== -1)
            return {
              group: u,
              option: g
            };
        }
      else
        return Oe(e.value, t);
    return -1;
  }, Ne = function() {
    return e.optionValue ? null : e.dataKey;
  }, Oe = function(t, u) {
    var g = Ne();
    return u.findIndex(function(O) {
      return S.equals(t, Ce(O), g);
    });
  }, lt = function(t) {
    return S.equals(e.value, Ce(t), Ne());
  }, ge = function() {
    te(!0);
  }, X = function() {
    te(!1);
  }, He = function(t) {
    yt.set("overlay", E.current, Xe.autoZIndex, Xe.zIndex.overlay), De(), t && t();
  }, Ge = function(t) {
    t && t(), ce(), e.onShow && e.onShow();
  }, it = function() {
    re();
  }, We = function() {
    e.filter && e.resetFilterOnHide && Se(), yt.clear(E.current), e.onHide && e.onHide();
  }, De = function() {
    j.alignOverlay(E.current, k.current.parentElement, e.appendTo || Xe.appendTo);
  }, Ue = function() {
    var t = j.findSingle(E.current, "li.p-highlight");
    t && t.scrollIntoView && t.scrollIntoView({
      block: "nearest",
      inline: "nearest"
    });
  }, Ie = function(t) {
    k.current && (k.current.value = t ? p(t) : e.value || "");
  }, p = function(t) {
    return e.optionLabel ? S.resolveFieldData(t, e.optionLabel) : t && t.label !== void 0 ? t.label : t;
  }, Ce = function(t) {
    return e.optionValue ? S.resolveFieldData(t, e.optionValue) : t && t.value !== void 0 ? t.value : t;
  }, ut = function(t) {
    return e.dataKey ? S.resolveFieldData(t, e.dataKey) : p(t);
  }, ze = function(t) {
    return e.optionDisabled ? S.isFunction(e.optionDisabled) ? e.optionDisabled(t) : S.resolveFieldData(t, e.optionDisabled) : t && t.disabled !== void 0 ? t.disabled : !1;
  }, ot = function(t) {
    return S.resolveFieldData(t, e.optionGroupLabel);
  }, ct = function(t) {
    return S.resolveFieldData(t, e.optionGroupLabel);
  }, q = function(t) {
    return S.resolveFieldData(t, e.optionGroupChildren);
  }, ft = function() {
    if (e.editable && k.current) {
      var t = i ? p(i) : null, u = t || e.value || "";
      k.current.value = u;
    }
  }, st = function() {
    var t = me(e.options);
    return t !== -1 ? e.optionGroupLabel ? q(e.options[t.group])[t.option] : e.options[t] : null;
  };
  y.useImperativeHandle(r, function() {
    return {
      props: e,
      show: ge,
      hide: X,
      getElement: function() {
        return G.current;
      },
      getOverlay: function() {
        return E.current;
      },
      getInput: function() {
        return k.current;
      },
      getFocusInput: function() {
        return ne.current;
      }
    };
  }), y.useEffect(function() {
    S.combinedRefs(k, e.inputRef);
  }, [k, e.inputRef]), xt(function() {
    e.autoFocus && j.focus(ne.current, e.autoFocus);
  }), ve(function() {
    L && e.value && Ue();
  }, [L, e.value]), ve(function() {
    L && e.filter && De();
  }, [L, e.filter]), ve(function() {
    c && (!e.options || e.options.length === 0) && T(""), ft(), k.current && (k.current.selectedIndex = 1);
  }), Gt(function() {
    yt.clear(E.current);
  });
  var dt = function() {
    var t = {
      value: "",
      label: e.placeholder
    };
    if (i) {
      var u = Ce(i);
      t = {
        value: bt(u) === "object" ? e.options.findIndex(function(g) {
          return g === u;
        }) : u,
        label: p(i)
      };
    }
    return /* @__PURE__ */ I("div", {
      className: "p-hidden-accessible p-dropdown-hidden-select",
      children: /* @__PURE__ */ I("select", {
        ref: k,
        required: e.required,
        defaultValue: t.value,
        name: e.name,
        tabIndex: -1,
        "aria-hidden": "true",
        children: /* @__PURE__ */ I("option", {
          value: t.value,
          children: t.label
        })
      })
    });
  }, vt = function() {
    return /* @__PURE__ */ I("div", {
      className: "p-hidden-accessible",
      children: /* @__PURE__ */ I("input", {
        ref: ne,
        id: e.inputId,
        type: "text",
        readOnly: !0,
        "aria-haspopup": "listbox",
        onFocus: ye,
        onBlur: be,
        onKeyDown: Re,
        disabled: e.disabled,
        tabIndex: e.tabIndex,
        ...m
      })
    });
  }, mt = function() {
    var t = S.isNotEmpty(i) ? p(i) : null;
    if (e.editable) {
      var u = t || e.value || "";
      return /* @__PURE__ */ I("input", {
        ref: k,
        type: "text",
        defaultValue: u,
        className: "p-dropdown-label p-inputtext",
        disabled: e.disabled,
        placeholder: e.placeholder,
        maxLength: e.maxLength,
        onInput: Fe,
        onFocus: $e,
        onBlur: be,
        "aria-haspopup": "listbox",
        ...m
      });
    } else {
      var g = B("p-dropdown-label p-inputtext", {
        "p-placeholder": t === null && e.placeholder,
        "p-dropdown-label-empty": t === null && !e.placeholder
      }), O = e.valueTemplate ? S.getJSXElement(e.valueTemplate, i, e) : t || e.placeholder || "empty";
      return /* @__PURE__ */ I("span", {
        ref: k,
        className: g,
        children: O
      });
    }
  }, gt = function() {
    return e.value != null && e.showClear && !e.disabled ? /* @__PURE__ */ I("i", {
      className: "p-dropdown-clear-icon pi pi-times",
      onClick: je
    }) : null;
  }, w = function() {
    var t = B("p-dropdown-trigger-icon p-clickable", e.dropdownIcon), u = e.placeholder || e.ariaLabel;
    return /* @__PURE__ */ I("div", {
      className: "p-dropdown-trigger",
      role: "button",
      "aria-haspopup": "listbox",
      "aria-expanded": L,
      "aria-label": u,
      children: /* @__PURE__ */ I("span", {
        className: t
      })
    });
  }, a = Ze(), i = st(), f = S.isNotEmpty(e.tooltip), v = S.findDiffKeys(e, Ot.defaultProps), m = S.reduceKeys(v, j.ARIA_PROPS), s = B("p-dropdown p-component p-inputwrapper", {
    "p-disabled": e.disabled,
    "p-focus": z,
    "p-dropdown-clearable": e.showClear && !e.disabled,
    "p-inputwrapper-filled": S.isNotEmpty(e.value),
    "p-inputwrapper-focus": z || L
  }, e.className), b = dt(), F = vt(), N = mt(), M = w(), A = gt();
  return /* @__PURE__ */ ue(Ee, {
    children: [/* @__PURE__ */ ue("div", {
      ref: G,
      id: e.id,
      className: s,
      style: e.style,
      ...v,
      onClick: W,
      onMouseDown: e.onMouseDown,
      onContextMenu: e.onContextMenu,
      children: [F, b, N, A, M, /* @__PURE__ */ I(kt, {
        ref: E,
        visibleOptions: a,
        ...e,
        appendTo: x,
        onClick: ae,
        onOptionClick: nt,
        filterValue: c,
        hasFilter: R,
        onFilterClearIconClick: at,
        resetFilter: Se,
        onFilterInputKeyDown: Te,
        onFilterInputChange: rt,
        getOptionLabel: p,
        getOptionRenderKey: ut,
        isOptionDisabled: ze,
        getOptionGroupChildren: q,
        getOptionGroupLabel: ct,
        getOptionGroupRenderKey: ot,
        isSelected: lt,
        getSelectedOptionIndex: me,
        in: L,
        onEnter: He,
        onEntered: Ge,
        onExit: it,
        onExited: We
      })]
    }), f && /* @__PURE__ */ I(At, {
      target: G,
      content: e.tooltip,
      ...e.tooltipOptions
    })]
  });
}));
Ot.displayName = "Dropdown";
Ot.defaultProps = {
  __TYPE: "Dropdown",
  appendTo: null,
  ariaLabel: null,
  ariaLabelledBy: null,
  autoFocus: !1,
  className: null,
  dataKey: null,
  disabled: !1,
  dropdownIcon: "pi pi-chevron-down",
  editable: !1,
  emptyFilterMessage: null,
  emptyMessage: null,
  filter: !1,
  filterBy: null,
  filterInputAutoFocus: !0,
  filterLocale: void 0,
  filterMatchMode: "contains",
  filterPlaceholder: null,
  filterTemplate: null,
  id: null,
  inputId: null,
  inputRef: null,
  itemTemplate: null,
  maxLength: null,
  name: null,
  onBlur: null,
  onChange: null,
  onContextMenu: null,
  onFilter: null,
  onFocus: null,
  onHide: null,
  onMouseDown: null,
  onShow: null,
  optionDisabled: null,
  optionGroupChildren: null,
  optionGroupLabel: null,
  optionGroupTemplate: null,
  optionLabel: null,
  optionValue: null,
  options: null,
  panelClassName: null,
  panelStyle: null,
  placeholder: null,
  required: !1,
  resetFilterOnHide: !1,
  scrollHeight: "200px",
  showClear: !1,
  showFilterClear: !1,
  showOnFocus: !1,
  style: null,
  tabIndex: null,
  tooltip: null,
  tooltipOptions: null,
  transitionOptions: null,
  value: null,
  valueTemplate: null,
  virtualScrollerOptions: null
};
function wt(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var n = 0, l = new Array(r); n < r; n++)
    l[n] = e[n];
  return l;
}
function ln(e) {
  if (Array.isArray(e))
    return wt(e);
}
function un(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function on(e, r) {
  if (!!e) {
    if (typeof e == "string")
      return wt(e, r);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return wt(e, r);
  }
}
function cn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fn(e) {
  return ln(e) || un(e) || on(e) || cn();
}
var Ae = {
  DEFAULT_MASKS: {
    pint: /[\d]/,
    int: /[\d\-]/,
    pnum: /[\d\.]/,
    money: /[\d\.\s,]/,
    num: /[\d\-\.]/,
    hex: /[0-9a-f]/i,
    email: /[a-z0-9_\.\-@]/i,
    alpha: /[a-z_]/i,
    alphanum: /[a-z0-9_]/i
  },
  getRegex: function(r) {
    return Ae.DEFAULT_MASKS[r] ? Ae.DEFAULT_MASKS[r] : r;
  },
  onKeyPress: function(r, n, l) {
    if (!l && !(r.ctrlKey || r.altKey)) {
      var c = r.key.length === 1;
      if (!!c) {
        var T = this.getRegex(n);
        T.test(r.key) || r.preventDefault();
      }
    }
  },
  onPaste: function(r, n, l) {
    if (!l) {
      var c = this.getRegex(n), T = r.clipboardData.getData("text");
      fn(T).forEach(function(K) {
        if (!c.test(K))
          return r.preventDefault(), !1;
      });
    }
  },
  validate: function(r, n) {
    var l = r.target.value, c = !0;
    return l && !n.test(l) && (c = !1), c;
  }
}, It = /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef(function(e, r) {
  var n = y.useRef(r), l = function(L) {
    e.onKeyPress && e.onKeyPress(L), e.keyfilter && Ae.onKeyPress(L, e.keyfilter, e.validateOnly);
  }, c = function(L) {
    var te = !0;
    if (e.keyfilter && e.validateOnly && (te = Ae.validate(L, e.keyfilter)), e.onInput && e.onInput(L, te), !e.onChange) {
      var G = L.target;
      S.isNotEmpty(G.value) ? j.addClass(G, "p-filled") : j.removeClass(G, "p-filled");
    }
  }, T = function(L) {
    e.onPaste && e.onPaste(L), e.keyfilter && Ae.onPaste(L, e.keyfilter, e.validateOnly);
  }, K = n.current && n.current.value, h = y.useMemo(function() {
    return S.isNotEmpty(e.value) || S.isNotEmpty(e.defaultValue) || S.isNotEmpty(K);
  }, [e.value, e.defaultValue, K]);
  y.useEffect(function() {
    S.combinedRefs(n, r);
  }, [n, r]);
  var z = S.isNotEmpty(e.tooltip), H = S.findDiffKeys(e, It.defaultProps), Q = B("p-inputtext p-component", {
    "p-disabled": e.disabled,
    "p-filled": h
  }, e.className);
  return /* @__PURE__ */ ue(Ee, {
    children: [/* @__PURE__ */ I("input", {
      ref: n,
      ...H,
      className: Q,
      onInput: c,
      onKeyPress: l,
      onPaste: T
    }), z && /* @__PURE__ */ I(At, {
      target: n,
      content: e.tooltip,
      ...e.tooltipOptions
    })]
  });
}));
It.displayName = "InputText";
It.defaultProps = {
  __TYPE: "InputText",
  keyfilter: null,
  validateOnly: !1,
  tooltip: null,
  tooltipOptions: null,
  onInput: null,
  onKeyPress: null,
  onPaste: null
};
export {
  Ot as Dropdown,
  It as InputText,
  pt as OverlayService,
  Ye as VirtualScroller
};
